import { services } from "./data";

export const Services = () => (
    <section id="services" className="bg-slate-50 py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl mx-auto text-center mb-14">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-teal-600 mb-4">Our Services</p>
                <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
                    Complete Dental Care, All in One Place
                </h2>
                <p className="mt-4 text-base leading-relaxed text-slate-600">
                    From routine check-ups to advanced treatments, we cover the full range of dental care for every age.
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="services-grid">
                {services.map((s) => (
                    <article
                        key={s.title}
                        data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className="group bg-white rounded-2xl p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
                    >
                        <span className="h-12 w-12 rounded-xl bg-sky-50 flex items-center justify-center mb-5 transition-colors duration-300 group-hover:bg-teal-50">
                            <s.icon className="h-6 w-6 text-teal-600" strokeWidth={1.5} />
                        </span>
                        <h3 className="text-base font-semibold text-slate-900 mb-1.5">{s.title}</h3>
                        <p className="text-sm leading-relaxed text-slate-500">{s.desc}</p>
                    </article>
                ))}
            </div>
        </div>
    </section>
);
